import MarketTabSection from '../../../common/MarketTabSection';
import { useOrderDetails } from '../../OrderDetailsProvider';

import { CPLAT_API_ROUTES } from '@/api';
import { useAppSelector } from '@/redux/store';
import { useState } from 'react';

import { orderQueries, useFetch } from '@/api';
import { DEFAULT_PAGE_SIZE } from '@/constants/order';
import { LayoutStickySection, LayoutTables } from '@/pages/orders/_layouts/LayoutOrderContainer';
import LayoutTableController from '@/pages/orders/_layouts/LayoutTableController';
import type { CplatApiResponse } from '@/types/api';
import { Stores } from '@/types/stores';
import { formatISOString } from '@/utils/format-iso-string';
import { useSuspenseQuery } from '@tanstack/react-query';
import DateRangeSelect from '../../../common/DateRangeSelect';
import NotRegisteredState from '../../../common/NotRegisteredState';
import { SearchFilter } from '../../../common/SearchFilter';
import OrderTableColumn from './OrderTableColumn';
import { OrderSeachField } from '@/types/order-list';
import { useGetMarketIdFromSeachParams } from '@/hooks/use-get-market-id-from-search-params';
import { useSort } from '@/contexts/table-sort';

const Return = () => {
  const user = useAppSelector((state) => state.user);

  const [page, setPage] = useState(0);
  const [searchField, setSearchField] = useState<OrderSeachField>('ExternalProductInfo');
  const [searchKeyword, setSearchKeyword] = useState('');

  const {
    // 날짜 관련 상태와 함수
    startDate,
    endDate,
    handleStartDate,
    handleEndDate,
  } = useOrderDetails();
  const { storeId, marketId } = useGetMarketIdFromSeachParams();
  const { sort } = useSort();

  const getOrderChangeListQuery = useSuspenseQuery(
    orderQueries.getOrderChangeList({
      cplatToken: user.CplatToken,
      dateFrom: formatISOString(startDate),
      dateTo: formatISOString(endDate),
      skip: page * DEFAULT_PAGE_SIZE,
      take: DEFAULT_PAGE_SIZE,
      statusTab: 'ReturnRequest',
      ...(storeId && { storeId }),
      ...(marketId && { marketId: Number(marketId) }),
      ...(sort && { sortInfo: { sortColumn: sort.sortColumn, sortDirection: sort.sortDirection } }),

      ...(searchField &&
        searchKeyword && {
          searchField,
          searchKeyword,
        }),
    }),
  );

  const orderChangeListData = getOrderChangeListQuery.data?.data[0].orders;
  const totalPages = getOrderChangeListQuery.data?.data[0].pagination.totalPages;

  const { data: storeListData } = useFetch<CplatApiResponse<Stores[][]>>(
    CPLAT_API_ROUTES.getStores,
    {
      method: 'POST',
      params: { cplatToken: user.CplatToken },
      v3: true,
    },
  );

  return (
    <>
      {(storeListData?.data[0].length ?? 0) >= 1 ? (
        <>
          <LayoutStickySection>
            <MarketTabSection totalLength={orderChangeListData.length} />
          </LayoutStickySection>
          <LayoutTables isTableBorder>
            <LayoutTableController>
              <div className="flex gap-[20px]">
                <DateRangeSelect
                  startDate={startDate}
                  handleStartDate={handleStartDate}
                  endDate={endDate}
                  handleEndDate={handleEndDate}
                />
                <SearchFilter
                  searchField={searchField}
                  searchKeyword={searchKeyword}
                  setSearchKeyword={setSearchKeyword}
                  setSearchField={setSearchField}
                  onSearch={(keyword) => setSearchKeyword(keyword)}
                  onReset={() => setSearchKeyword('')}
                />
              </div>
            </LayoutTableController>
            <OrderTableColumn
              orderList={orderChangeListData ?? []}
              page={page}
              onChangePage={setPage}
              totalPages={totalPages ?? 0}
            />
          </LayoutTables>
        </>
      ) : (
        <NotRegisteredState className="bg-white" />
      )}
    </>
  );
};

export default Return;
